var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-screen',{staticClass:"animated fadeIn"},[_c('b-row',{staticClass:"mt-3"},[_c('b-col',{attrs:{"sm":"12","md":"4"}},[_c('execute-process',{attrs:{"process-id":_vm.processId}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }